// ANGULAR
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

// SERVICIOS
import { UserService } from './services/AsynchronousRequestServices/user.service';

// COMPONENTES
import { DropdownLogoutComponent } from './components/Templates/Navbar/dropdown-logout.component';
import { ProgressComponent } from './components/Templates/Progress/progress.component';
import { NavbarComponent } from './components/Templates/Navbar/navbar.component';
import { IndexComponent } from './components/Pages/Index/index.component';
import { ErrorComponent } from './components/Pages/Error/error.component';
import { AppComponent } from './app.component';

// MODULOS
import { SharedModuleModule } from './components/shared-module.module';
import { AppRoutingModule } from './app-routing.module';

// CONFIGURACION REGIONAL
import localeCOLExtra from '@angular/common/locales/extra/es-CO';
import { registerLocaleData } from '@angular/common';
import localeCOL from 'src/assets/scripts/es-CO';

registerLocaleData(localeCOL, 'es-CO', localeCOLExtra);

@NgModule({
  declarations: [
    DropdownLogoutComponent,
    ProgressComponent,
    NavbarComponent,
    IndexComponent,
    ErrorComponent,
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    SharedModuleModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserModule,
    RouterModule,
  ],
  exports: [],
  providers: [UserService, { provide: LOCALE_ID, useValue: 'es-CO' }, { provide: DEFAULT_CURRENCY_CODE, useValue: 'COP' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
